import React from 'react';
import { useInit } from '../../../Contexts/InitProvider';
import SelectWithCheck from '../../../features/CustomInput/SelectWithCheck';
import ReloadButton from '../../../features/ReloadButton/ReloadButton';
import { InputFieldSearch, SelectOption, addOption } from '../../../utils/InputField';

function PageHeaderLeftCol({ filterHandler, p }) {
    const { initInfo } = useInit();
    const pkgTime = [
        {
            key: 'ppu',
            value: 'Pay Per Use'
        },
        {
            key: 'duration',
            value: 'Duration'
        },
        {
            key: 'lifetime',
            value: 'Life Time'
        }
    ];
    return (
        <form className="subscriptions_page_header_left_col flex-1 flex items-center gap-x-3">
            <InputFieldSearch
                label="Search by subs name or customer or email..."
                name="q"
                formData={p}
                onChange={filterHandler}
                className="rounded-10 w-68"
            />
            <SelectWithCheck
                title="Application"
                name="applications"
                formData={p}
                onChange={filterHandler}
                options={initInfo.applications.map(({ id, applicationTitle: title }) =>
                    addOption(id.toString(), title, id.toString())
                )}
                className="rounded-10 w-56"
            />
            <SelectOption
                placeholder="Limit By"
                name="limit-by"
                formData={p}
                onChange={filterHandler}
                options={pkgTime.map(({ key, value }) => addOption(key, value, key))}
                className="rounded-10 w-36"
            />
            <SelectOption
                placeholder="Status"
                name="status"
                formData={p}
                onChange={filterHandler}
                options={['Active', 'Expired', 'Expire-soon'].map((d) =>
                    addOption(d, d, d.toLowerCase())
                )}
                className="rounded-10 w-36"
            />
        </form>
    );
}

function SubscriptionsPageHeader({ p, filterHandler, handleReload }) {
    return (
        <div className="subscription_page_header mb-7 flex flex-row justify-between items-center">
            <PageHeaderLeftCol p={p} filterHandler={filterHandler} />
            <ReloadButton height="h-10" width="w-10" onClick={handleReload} />
        </div>
    );
}

export default SubscriptionsPageHeader;
